import { API } from '@constants';

function login() {
  window.location.assign(
    `${API.SIGNIN}?redirectPath=${encodeURIComponent(window.location.pathname)}`
  );
}

export default {
  login
};
